<div class="prouduct bgm-white p-10">
  <div class="p-30 fx-row">
    <div class="bg-white-smoke fx-col gt-sm-fx-row fx-main-center fx-cross-center fx-fill-size fx-flex">
      @if (selectedCategory.CategoryId=='10') {
        <div  class="fx-col fx-main-center fx-cross-center fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col lt-md-fx-order-2">
          <div class="content p-l-30 p-r-30 fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col lt-md-fx-flex-100-in-col">
            <p class="m-t-12 f-s-24 f-w-700">Womens</p>
            <p class="m-t-20 f-s-14 w-72">Made from sustainable materials with labour standards we're proud of. Our small
            collection is inspired by years of working with athletes. Each piece is created to ensure performance.</p>
          </div>
        </div>
      }
      @if (selectedCategory.CategoryId=='10') {
        <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col lt-md-fx-order-1">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/collections/HP_BANNER_DT_2000x_c65dfc3f-5b90-47f9-ad72-f4bf67bc6e8b_720x.jpg?v=1600989067"
            alt="product-image" width="100%">
        </div>
      }
      @if (selectedCategory.CategoryId=='11') {
        <div  class="fx-col fx-main-start fx-cross-stretch fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col lt-md-fx-order-2">
          <div class="content p-l-30 p-r-30 fx-col fx-main-start fx-cross-stretch fx-flex-50-in-col">
            <p class="m-t-12 f-s-24 f-w-700">Mens</p>
          </div>
        </div>
      }
      @if (selectedCategory.CategoryId=='11') {
        <div  class="fx-col fx-main-center fx-cross-stretch fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col lt-md-fx-order-1">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/collections/LNDR_Mens_homepage_300x300.png?v=1601056370"
            alt="product-image" width="100%">
        </div>
      }
    </div>
  </div>
  <!-- products -->
  <div class="p-30">
    <div class="fx-row xs-fx-col fx-main-start fx-cross-start xs-fx-gap-bottom-20px print-fx-gap-right-20px gt-xs-fx-gap-right-20px">
      <div class="m-t-40 w-100 xs-fx-flex-100-in-col print-fx-flex-25 gt-xs-fx-flex-25">
        <!-- start -->
        <div class="main fx-row fx-main-center fx-cross-center">
          <div class="firstContainer fx-col fx-flex-80">
            <div>
              <span class="color1-f-s-17 f-w-700" translate="search_product"></span>
            </div>
            <div class="m-t-10">
              <form>
                <div class="fx-row fx-main-center fx-cross-center">
                  <div class="searchBox fx-row fx-flex-100">
                    <mat-form-field appearance="outline" class="design fx-flex">
                      <mat-label>What are you looking for?</mat-label>
                      <input name="search" [(ngModel)]="productSearchText" [ngModelOptions]="{standalone: true}"
                        matInput>
                      <mat-icon class="m-t-10" matSuffix>search</mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
            <hr style="border-color:rgba(0,0,0,0.1)">
            <div class="m-t-10">
              <span class="color1-f-s-17 f-w-700" translate="category_"></span>
            </div>
            <div class="m-t-10 borderBottom">
              <div class="m-l-15">
                <form class="fx-row">
                  <div class="fx-col fx-flex-100">
                    <div class="checkBox">
                      <mat-checkbox id="all" [(ngModel)]="itemsListService.selectedCategories['all']"
                        (change)="itemsListService.getItemsByCategory()" [ngModelOptions]="{standalone: true}"
                      class="text-uppercase" color="warn">{{'shop_all_' | translate}}</mat-checkbox>
                    </div>
                    @for (category of itemsListService.categoryList; track category) {
                      <div class="checkBox">
                        <mat-checkbox [(ngModel)]="itemsListService.selectedCategories[category.CategoryId]"
                          [attr.id]="category.CategoryId"
                          (change)="onChange(itemsListService.selectedCategories)"
                          [ngModelOptions]="{standalone: true}" color="warn" class="text-uppercase">{{category.Category}}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </form>
              </div>
            </div>
            <hr class="m-t-10" style="border-color:rgba(0,0,0,0.1)">
            <div class="m-t-10">
              <div>
                <span class="color1-f-s-17 f-w-700" translate="sort_by"></span>
              </div>
              <div class="m-t-10">
                <form>
                  <div class="sortBy">
                    <mat-form-field appearance="outline" class="w-100 design">
                      <mat-select [(ngModel)]="sortByOrder" [compareWith]="compareObjects"
                        (selectionChange)="onChangeSorting($event)" [ngModelOptions]="{standalone: true}">
                        @for (keys of sortKeys; track keys) {
                          <mat-option [value]="keys"> {{keys.name | translate}} - {{keys.lname
                          | translate}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-t-10 fx-row-wrap fx-main-start fx-cross-start xs-fx-flex-75-in-col print-fx-flex-75 gt-xs-fx-flex-75">
        @for (productImage of itemsListService.productList  | productSearch:productSearchText | productOrderBy:sortByOrder; track productImage; let i = $index) {
          <div
            class="m-t-30 p-10 fx-col fx-main-center fx-cross-stretch fx-fill-size fx-flex-32-in-wrap xs-fx-flex-100 sm-fx-flex-48-in-wrap">
            <div (mouseover)="mouseEnter(i)"
              (mouseout)="mouseOut(i)" class="p-relative fx-col fx-main-center fx-cross-center fx-fill-size fx-flex-70-in-col lt-md-fx-flex-100-in-col">
              <img (click)="goToShop(productImage.ItemID)" [src]="env.imageUrl +productImage.ImageUrl" alt=""
                class="img-bg cursor-pointer" [id]="'product'+i" style="width: 100% !important;">
              <div class="content fx-col fx-main-end fx-cross-stretch fx-fill">
                <div id="div" class="p-absolute abs-width">
                  <button [id]="'btn'+i" class="shop-btn product-button d-none w-89 m-t-20 m-b-20 m-r-0 m-l-0"
                  mat-raised-button color="black" (click)="handleProduct(productImage)">Quick Add</button>
                </div>
              </div>
            </div>
            <div class="content m-t-20 fx-row fx-flex-10-in-col">
              <div class="fx-flex-70">
                <p><span class="font-IBM">{{productImage.ProductName}}</span></p>
                <p><span class="m-t-10 font-IBM">@if (productImage.oldPrice) {
                  <del>{{productImage.oldPrice}} </del>
                }
              {{'$'+productImage.Price}}</span></p>
            </div>
            @if (productImage.oldPrice) {
              <div class="text-end m-t-10 fx-flex-30">
                <p class="f-s-12 sale" color="white">Sale</p>
              </div>
            }
          </div>
        </div>
      }
      @if (itemsListService.productList.length === 0) {
        <div class="w-100 text-center m-50">
          No Products found!!
        </div>
      }
    </div>
  </div>
</div>
<hr style="margin: 40px 28px 0px 28px; border-color:rgba(0,0,0,0.1)">
<!-- Featured collection -->
<div class="p-30">
  <div class="fx-col">
    <p class="f-s-24 f-w-700">Featured collection</p>
    <div class="fx-row-wrap fx-main-start fx-cross-start">
      @for (productImage of products; track productImage; let i = $index) {
        <div
          class="m-t-30 p-10 fx-col fx-main-center fx-cross-stretch fx-fill-size fx-flex-32-in-wrap lt-md-fx-flex-100">
          <div (mouseover)="mouseEnter(i+1000)"
            (mouseout)="mouseOut(i+1000)" class="p-relative fx-col fx-main-center fx-cross-center fx-fill-size fx-flex-70-in-col lt-md-fx-flex-100-in-col">
            <img
              (click)="goToShop(productImage.ItemID)" [src]="env.imageUrl +productImage.ImageUrl" alt=""
              class="img-bg cursor-pointer xs-ew-height-380px" [id]="'product'+(i+1000)" style="width: 100% !important;">
            <div class="content fx-col fx-main-end fx-cross-stretch fx-fill">
              <div class="p-absolute abs-width">
                <button [id]="'btn'+(i+1000)" class="shop-btn product-button d-none w-89 m-t-20 m-b-20 m-r-0 m-l-0"
                mat-raised-button color="black" (click)="handleProduct(productImage)">Quick Add</button>
              </div>
            </div>
          </div>
          <div class="content m-t-20 fx-row fx-flex-10-in-col">
            <div class="fx-flex-70">
              <p><span class="font-IBM">{{productImage.ProductName}}</span></p>
              <p><span class="m-t-10 font-IBM">@if (productImage.oldPrice) {
                <del>{{productImage.oldPrice}} </del>
              }
            {{'$'+productImage.Price}}</span></p>
          </div>
          @if (productImage.oldPrice) {
            <div class="text-end m-t-10 fx-flex-30">
              <p class="f-s-12 sale" color="white">Sale</p>
            </div>
          }
        </div>
      </div>
    }
    @if (products.length === 0) {
      <div class="w-100 text-center m-30 p-20">
        No Products found!!
      </div>
    }
  </div>
</div>
</div>
<!-- Best Seller -->
<div class="p-30">
  <div class="fx-col">
    <div class="bg-img p-relative fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col">
      <img src="https://cdn.shopify.com/s/files/1/0926/9298/files/Banner_03.jpg?v=1600973446&width=1512" alt="image">
      <div class="content p-abs c-white">
        <div class="p-relative p-content-div text-center">
          <p><span class="f-s-12">
            FAVOURITES
          </span></p>
          <p class="m-t-12 f-s-36 f-w-700">Best Sellers</p>
          <p class="m-t-20">Shop our best selling collection - everything from the perfect pair of tights, to totally
          matching sweat suits.</p>
          <p class="m-t-30 shop-btn"><a class="c-white f-s-14" routerLink="/products/all">Shop now</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
